module.exports = __webpack_public_path__ + "media/images/social/youtube-ffc690b39437141b73565a724162466e.png";